import { render, staticRenderFns } from "./RiskMatrix.vue?vue&type=template&id=2c76ec6d&"
import script from "./RiskMatrix.vue?vue&type=script&lang=js&"
export * from "./RiskMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports